import Button from 'atoms/Button';
import cn from 'classnames';
import React from 'react';
import { navigateToUrl } from 'utils/navigateUtils';
import { generateRandomString } from 'utils/urlUtils';

import s from './Navigation.module.scss';

interface ISignInNav {
  name: string;
  transparent: boolean;
  dark: boolean;
  isSticky?: boolean;
}

const SignInNav = ({ name, transparent, dark, isSticky }: ISignInNav) => {
  return (
    <Button
      className={cn(s.Navigation__link, s.Navigation__signin__btn, s.Navigation__content_item, {
        transparent,
        dark,
        isSticky
      })}
      variant="text"
      onClick={() => navigateToUrl('/connect/signIn', { query: { tk: generateRandomString(4) } })}
    >
      {name}
    </Button>
  );
};

export default SignInNav;
